import { useEffect, useRef } from 'react';
import { useEasterEgg } from '../context/EasterEggContext';

const EasterEggEffect = () => {
  const { isEasterEggActive } = useEasterEgg();
  const observerRef = useRef(null);
  const originalSourcesRef = useRef(new Map());

  const replaceImages = (images) => {
    const map = originalSourcesRef.current;
    for (let i = 0; i < images.length; i++) {
      const img = images[i];
      if (!map.has(img)) {
        map.set(img, img.src);
      }
      img.src = '/doggo.png';
      img.classList.add('easter-egg-image');
    }
  };

  useEffect(() => {
    if (isEasterEggActive) {
      const allImages = document.getElementsByTagName('img');
      replaceImages(allImages);

      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList') {
            const newImages = [];
            mutation.addedNodes.forEach(node => {
              if (node.nodeName === 'IMG') {
                newImages.push(node);
              } else if (node.getElementsByTagName) {
                const nestedImages = node.getElementsByTagName('img');
                for (let i = 0; i < nestedImages.length; i++) {
                  newImages.push(nestedImages[i]);
                }
              }
            });
            if (newImages.length > 0) {
              replaceImages(newImages);
            }
          }
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
      observerRef.current = observer;
    } else {
      const map = originalSourcesRef.current;
      const allImages = document.getElementsByTagName('img');
      for (let i = 0; i < allImages.length; i++) {
        const img = allImages[i];
        const originalSrc = map.get(img);
        if (originalSrc) {
          img.src = originalSrc;
          img.classList.remove('easter-egg-image');
        }
      }
      originalSourcesRef.current.clear();

      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
    }

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
    };
  }, [isEasterEggActive]);

  return null;
};

export default EasterEggEffect;
